module.exports = __webpack_public_path__ + "static/media/shape.5c793385.svg";